const logotext = "Home";
const meta = {
    title: "Frederic Desjardins",
    description: "",
};

const introdata = {
    title: "Hello,",
    animated: {
        first: "My Name is Frederic",
        second: "Welcome to my website",
    },
    description: "Browse",
};

const dataabout = {
    title: "Overview",
    aboutme: "I have a passion for bringing interesting ideas to life. This has always motivated me to pursue different interests such as music, technology. I have an eye for design and the ability to bring a creative aspect to whatever project I am working on. I am always willing to try new things and see new perspectives.",
};


const skills = [{
    title: "Software Development",
    description: "I am a full-stack software engineer capable of creating interactive user interfaces as well as write asychronous back-end code for web application's and API's. I have experience building cloud based web and mobile applications hosted in AWS and Azure with frameworks like react, flutter and ASP.NET. I previously worked on developing containerized microservices with Golang using Docker and Kubernetes. You will find my resume below with a more detailed view of my technical skills. ",
},
{
    title: "Communication",
    description: "I take pride in my excellent communication skills. I have demonstrated this by effectively translating business requirements into technical specifications, creating project plans, and collaborating with team members, clients, and non-technical people to achieve organizational goals. I am proficient in three languages and enjoy preparing and giving presentations and demos."
},
{
    title: "Organization",
    description: "I have great project planning skills and a natural sense for organization. I thrive in fast-paced collaborative environment. I have experience contributing to all aspects of a project from an initial vision, through requirements definition and detailed design, and finally development and deployment of a working product.",
},
];

const dataportfolio = [

    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The Fix It App",
        link: "https://www.algonquincollege.com/arie/2021/12/december-2021-showcase-winners/",
    },

    {
        img: "https://picsum.photos/400/?grayscale",
        description: "Web application with Jakarta EE",
        link: "https://github.com/Fredotez/Java-Projects/tree/main/Assignment2-Web",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "Platypus Compiler",
        link: "https://github.com/Fredotez/Compilers",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "Web Application with ASP.Net",
        link: "https://github.com/Fredotez/CST8359-.Net",
    },

];

const contactConfig = {
    YOUR_EMAIL: "fmdesjardins2000@gmail.com",
    YOUR_FONE: "(613)-850-3375",
    description: "Please fill out the following form and I will respond ASAP.",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_9z5cjvl",
    YOUR_TEMPLATE_ID: "template_tyfpv0o",
    YOUR_USER_ID: "Jor0n-_gsE602LGnn",
};

const socialprofils = {
    github: "https://github.com/Fredotez",
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com/in/frederic-desjardins",
    youtube: "https://youtube.com",
};
export {
    meta,
    dataabout,
    dataportfolio,
    skills,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
